import React from "react";
import Text from '../text/Text'
import { PartnerCard } from "../partnerCard";
import { partnersData } from "../../data/partners";
import './styles.css';

const Partners = () => {

    return(
        <div className="container">
            <div className="content" >
                <div>
                    <Text as="h1" fontSize={56} variant='yellow-green'>Nossos Parceiros</Text>
                    <Text as="p" fontSize={22}>Conheça o time de parceiros do ÌMÒLAB</Text>
                </div>
                <div id='partners-content'>
                    {partnersData.map(partner => (
                        <PartnerCard key={partner.id} partner={partner} />
                    ))}
                </div>
            </div>
        </div>
    )
}
export default Partners;